export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13928.278b9420.jpg";